import type { ResolvedWorkingHours } from '@/types/workingHours'
import { log } from './logger'

// Re-export pure utilities from working-hours (no native dependencies)
export {
    compareTime,
    dateToTime,
    formatTime,
    getNextWorkingPeriodStart,
    isCurrentlyWithinWorkingHours,
    isValidTimeRange,
    mergeWorkingHours,
    parseTime,
    resolveWorkingHours,
    timeToDate,
} from './working-hours'

export function buildLocationSchedule(_hours: ResolvedWorkingHours): string[] {
    return []
}

// ============================================================================
// Native-only stubs — these are no-ops on web
// ============================================================================

export async function getDeviceTrackingDisabled(): Promise<boolean> {
    return true
}

export async function setDeviceTrackingDisabled(_disabled: boolean): Promise<void> {}

export function resetAuthFailureFlag(): void {}

export async function bootstrapBackgroundGeolocation() {
    log.debug('[geo-tracking] Not available on web')
}

export type TrackingMode =
    | { kind: 'off' }
    | { kind: 'continuous' }
    | { kind: 'scheduled'; schedule: string[] }

// Web stub for the native SDK state shape. Web callers never instantiate
// this — `Platform.OS === 'web'` is guarded everywhere — but the type must
// exist for type-only imports to resolve.
export interface PluginState {
    enabled: boolean
    schedulerEnabled: boolean
    trackingMode: number
    app?: { schedule?: string[] }
}

export function resolveTrackingMode(_opts: {
    deviceDisabled: boolean
    userDisabled: boolean
    isPaused: boolean
    workingHours: ResolvedWorkingHours
}): TrackingMode {
    return { kind: 'off' }
}

export async function applyTrackingMode(_mode: TrackingMode): Promise<void> {}

export async function updateAuthToken(_token: string) {}

export async function syncActiveLocations() {}

export async function registerBackgroundSync() {}

export async function unregisterBackgroundSync() {}
